exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-bar{\r\n    height: 66px;\r\n}\r\n\r\n.title{\r\n    width: 50%;\r\n    color: white;\r\n    float: left;\r\n}\r\n\r\n.logo{\r\n    float: left;\r\n    width: 40%;\r\n}\r\n\r\n.cor-valia{\r\n    background-color: #09559f;\r\n}\r\n\r\nimg{\r\n    height: 66px;\r\n    float: right;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/navegacao/top-bar/top-bar.component.css
// module id = ../../../../../src/app/navegacao/top-bar/top-bar.component.css
// module chunks = 1